<template>
  <smd-one-col-layout class="modal-service-order-cancel">
    <full-screen-loader v-if="loading"/>

    <div class="smd-form__row">
      <text-string label-id="txt274"/>
    </div>

    <div class="smd-form__row">
      <smd-textarea v-model="message"/>
    </div>

    <div class="smd-form__row flex-row-center-xy-spaced m-t-15">
      <smd-btn section="4"
               variant="unselected"
               @click="closeModal">
        <text-string label-id="txt261"/>
      </smd-btn>
      <smd-btn section="4"
               :variant="computedVariant"
               @click="submit">
        <text-string label-id="txt275"/>
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import {MedicineService} from '@/services/medicine';

  export default {
    name: 'modal-report-issue',
    mixins: [CloseModalMixin],
    props: {
      orderid: {type: String, required: true},
    },
    data() {
      return {
        loading: false,
        message: '',
      };
    },
    computed: {
      computedVariant() {
        return this.message !== '' ? 'blue-enabled' : 'blue-disabled';
      },
    },
    methods: {
      async submit() {
        this.loading = true;

        try {
          await MedicineService.reportOrder(this.orderid, this.message);
          this.loading = false;
          this.closeModal();
        } catch (error) {
          this.loading = false;
        }
      },
    },
  }
</script>

<style>

</style>
txt270
txt271

txt401
txt301